import React from "react";
import HistorialEntregas from "@/components/HistorialEntregas";

export default function MiHistorial() {
  return (
    <div className="space-y-5" data-testid="mi-historial-page">
      <div><h1 className="text-2xl font-bold">Mi historial</h1><p className="text-sm text-muted-foreground">Todas las entregas que has atendido</p></div>
      <HistorialEntregas />
    </div>
  );
}
